const initVariationPriceUpdate = ($) => {
    const form = document.querySelector('.variations_form');
    const dynamicPrice = document.querySelector('.dynamic-price .price');

    if (!form || !dynamicPrice) {
        return;
    }

    const defaultDynamicPrice = dynamicPrice.innerHTML;

    $('.variations_form').on('show_variation', function () {
        const price = document.querySelector('.woocommerce-variation-price .price');
        if (price) {
            dynamicPrice.innerHTML = price.innerHTML;
        }
    });

    $('.variations_form').on('reset_data', function () {
        dynamicPrice.innerHTML = defaultDynamicPrice;
    });
};

const waitForJQuery = (callback) => {
    if (typeof jQuery === 'undefined') {
        setTimeout(() => waitForJQuery(callback), 100);
    } else {
        callback(jQuery);
    }
};

export default () => {
    waitForJQuery(($) => {
        $(document).ready(() => {
            initVariationPriceUpdate($);
        });
    });
};
